import React from 'react';

const SearchField = ({ input: { onChange, value, name } }) => (
  <input
    type="text"
    className="search-field"
    name={name}
    onChange={onChange}
    value={value}
    placeholder="Recherche..."
  />
);

export default SearchField;



// WEBPACK FOOTER //
// ./book/src/commons/components/layout/header/search/SearchField.jsx